(function () {
  function openModal(id) {
    var modal = document.querySelector(
      '[data-measurement-guide-modal="' + id + '"]',
    );
    if (!modal) return;
    modal.removeAttribute("hidden");
    requestAnimationFrame(function () {
      modal.classList.add("is-open");
    });
    document.body.style.overflow = "hidden";
    var btn = modal.querySelector("[data-measurement-guide-close]");
    if (btn) btn.focus();
    modal._trigger = document.querySelector(
      '[data-measurement-guide-open="' + id + '"]',
    );
  }

  function closeModal(id) {
    var modal = document.querySelector(
      '[data-measurement-guide-modal="' + id + '"]',
    );
    if (!modal) return;
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
    if (modal._trigger) modal._trigger.focus();
    modal.addEventListener("transitionend", function h() {
      modal.setAttribute("hidden", "");
      modal.removeEventListener("transitionend", h);
    });
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-measurement-guide-open]");
    if (opener) {
      openModal(opener.dataset.measurementGuideOpen);
      return;
    }

    var closer = e.target.closest("[data-measurement-guide-close]");
    if (closer) {
      closeModal(closer.dataset.measurementGuideClose);
      return;
    }

    var overlay = e.target.closest("[data-measurement-guide-modal]");
    if (overlay && e.target === overlay) {
      closeModal(overlay.dataset.measurementGuideModal);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var open = document.querySelector("[data-measurement-guide-modal].is-open");
    if (open) closeModal(open.dataset.measurementGuideModal);
  });
})();
